import type { ApiError } from '../api/apiError';
import { toFriendlyErrorMessage } from './friendlyError';

export function formatApiError(error: unknown): ApiError {
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const value = error as ApiError;
    const normalized: ApiError = {
      message:
        typeof value.message === 'string'
          ? value.message
          : 'Something went wrong. Please try again.',
      code: value.code,
      statusCode: value.statusCode,
      requestId: value.requestId,
    };
    return {
      ...normalized,
      message: toFriendlyErrorMessage(normalized),
    };
  }
  return { message: 'Something went wrong. Please try again.' };
}
